import React from 'react';

const SvgArrowTop = props => (
  <svg width={8} height={5} {...props}>
    <path
      d="M7.805 3.805L4.495.495a.7.7 0 0 0-.99 0l-3.31 3.31A.7.7 0 0 0 .69 5h6.62a.7.7 0 0 0 .495-1.195z"
      fill="#046FE2"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgArrowTop;
